export default "__VITE_ASSET__BYWUXA_V__"